// extracted by mini-css-extract-plugin
module.exports = {"auth":"styles_auth__yD3yn","link":"styles_link__2FNy6","sidebar":"styles_sidebar__2klut","searchIcon":"styles_searchIcon__1mzJK"};